import Markdown from 'react-markdown';
import remarkSuperSub from 'remark-supersub';

export const MarkdownWrapper = ({ children, className = '' }) => (
  <div className={`[&_sub]:text-xl [&_sup]:text-xl [&_a]:underline [&_a]:text-pdteal ${className}`}>
    <Markdown remarkPlugins={[remarkSuperSub]}>{children}</Markdown>
  </div>
);
